import axios from 'axios';

const API_URL = 'https://libro-nest.onrender.com/BookstoreAPI/api'; // Replace with your Render URL

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Books
export const createBook = (book) => api.post('/books', book);
export const getBooks = () => api.get('/books');
export const getBook = (id) => api.get(`/books/${id}`);
export const updateBook = (id, book) => api.put(`/books/${id}`, book);
export const deleteBook = (id) => api.delete(`/books/${id}`);

// Authors
export const createAuthor = (author) => api.post('/authors', author);
export const getAuthors = () => api.get('/authors');
export const getAuthor = (id) => api.get(`/authors/${id}`);
export const updateAuthor = (id, author) => api.put(`/authors/${id}`, author);
export const deleteAuthor = (id) => api.delete(`/authors/${id}`);
export const getAuthorBooks = (id) => api.get(`/authors/${id}/books`);

// Customers
export const createCustomer = (customer) => api.post('/customers', customer);
export const getCustomers = () => api.get('/customers');
export const getCustomer = (id) => api.get(`/customers/${id}`);
export const updateCustomer = (id, customer) => api.put(`/customers/${id}`, customer);
export const deleteCustomer = (id) => api.delete(`/customers/${id}`);

// Cart
export const addToCart = (customerId, item) => api.post(`/customers/${customerId}/cart/items`, item);
export const getCart = (customerId) => api.get(`/customers/${customerId}/cart`);
export const updateCartItem = (customerId, bookId, item) => api.put(`/customers/${customerId}/cart/items/${bookId}`, item);
export const removeCartItem = (customerId, bookId) => api.delete(`/customers/${customerId}/cart/items/${bookId}`);

// Orders
export const createOrder = (customerId) => api.post(`/customers/${customerId}/orders`);
export const getOrders = (customerId) => api.get(`/customers/${customerId}/orders`);
export const getOrder = (customerId, orderId) => api.get(`/customers/${customerId}/orders/${orderId}`);

export default api;